import { Context } from '@/models/order-history/status/context/context'
import { reorderIsAcceptable } from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state'
import { CreateStateCommandForExternalPayment } from '@spa/components/organisms/mypage/order/model/reorder-acceptability-state/for-external-payment'
import { none, Option, some } from 'fp-ts/lib/Option'

interface ReorderNotificationView {
  title: string
  descriptions: string[]
  link: string
  buttonLabel: string
}

const displayNotification: ReorderNotificationView = {
  title: '決済が完了していないご注文があります',
  buttonLabel: '決済を再開する',
  descriptions: [
    'マイページ＞ご購入履歴からご注文の決済を再開していただけます。',
    '1時間以上決済が確認できない場合は、ご注文を自動でキャンセルさせていただきます。',
  ],
  link: '/mypage/order', // SPA内の遷移を想定
}

interface BehaviorMinimumDep {
  cart: {
    notification: {
      reorder: {
        show: boolean
      },
    },
  },
}

/**
 * 再注文への誘導表示の文言類を返却する.
 *
 * 内部的に再注文の「可否」のロジックを利用しているが、独自の条件も含んでいるためイコールではない
 * 例えば下記
 * - behavior.jsonで表示設定にされている場合のみ誘導を行う
 * - 外部決済の場合のみ誘導を行う
 */
export function getReorderNotificationView(
  context: Pick<Context, 'engineStatus' | 'historyErrorList' | 'paymentType'>,
  behavior: BehaviorMinimumDep
): Option<ReorderNotificationView> {
  if (!behavior.cart.notification.reorder.show) {
    return none
  }

  // 外部決済で再決済受付状態の場合は誘導を行う
  const commandForExternalPayment = new CreateStateCommandForExternalPayment()
  if (
    commandForExternalPayment.shouldApply(context) &&
    reorderIsAcceptable(commandForExternalPayment.execute(context))
  ) {
    return some(displayNotification)
  }

  return none
}
